import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import dots_loader from "../../Assets/dot_loader.gif";
import "./logsModal.css";
import { terminate } from "../../Redux/actions/processes";

function ViewLogs(props){
    
    const [logs, setLogs] = useState('');
    const [connecting, setConnecting] = useState(false)
    let [ wr_id , setWrId ] =useState()
    let [ terminateLable, setTerminateLable ] = useState(false)

    useEffect(() => {
        let { log_data, status, worker_id } = props.logs
        setWrId(worker_id)
        if(status === "INPROGRESS"){
            try{
                setTerminateLable(true)
                setConnecting(true)
                const ws = new WebSocket(`${window._env.REACT_APP_EMCONSOLE_WEBSOCKET_URL}/web?key=${worker_id}`);
                let liveLogs = ''
                ws.onmessage = (obj)=>{
                    setConnecting(false)
                    let { data } = obj
                    let { msg } = JSON.parse(data)
                    liveLogs += msg
                    setLogs(liveLogs);
                    let last_child = document.getElementById("logs")?document.getElementById("logs").lastChild:""
                    if(last_child) last_child.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
                }
            }
            catch(err){
                console.log("emc.techforce.ai")
            }
        }else{
            setLogs(log_data);
        }
        
    },[props.logs]);

    let processTerminate=(worker_id)=>{
        if(worker_id)
            terminate(worker_id)
    }
    
    return (
        <div className="logs-container">
          <Modal isOpen={props.modal} className="log-modal" >
            <ModalHeader style={{ borderBottom: "none" }} toggle={props.toggle}>
                Logs Container  
                { terminateLable ?
                    <span style={{float: "right" ,  marginLeft: "5px"}}> 
                        <button  className="terminate" onClick={()=>processTerminate(wr_id)}>Terminate</button> 
                    </span>:""
                }
            </ModalHeader>
            <ModalBody>
                <div id="logs" className="logs-content">
                    { connecting ? 
                        <div className="text-center mt-3">
                            <i className="fas fa-desktop" style={{fontSize:"60px", margin:"25px 0px"}}></i>
                            <p>Please wait for a while for provisioning Live Logs</p>
                            <img src={dots_loader} style={{height:"100px"}} alt=""></img>
                        </div> : logs ? logs.split('\n').map((log, index) => <p key={index}>{log}</p>) : "" }
                </div>
            </ModalBody>
          </Modal>
        </div>
      );
}

export default ViewLogs;